import React from 'react';
import { Mutation } from "react-apollo"
import { REPLY_TO_BLOG_COMMENT } from "../queries";
import { getUserId, getUserType } from '../../../utils/localStorage';

const AddReplyButton = ({commentId,content,refetchBlog,setContent}) => {
    return(
        <Mutation mutation={REPLY_TO_BLOG_COMMENT}
            variables={{replierId:getUserId(), replierType:getUserType(), commentId:commentId, content:content}}
            onCompleted={refetchBlog}>

            {(addComment, { loading, error }) => (
                <div className='replyButton' onClick={() => {
                    if (content) {
                        addComment()
                        setContent("")
                    }
                }}>
                    Reply
                </div>
            )}

          </Mutation>
    )
}

export default AddReplyButton;


// WEBPACK FOOTER //
// ./src/components/Blogs/Comments/AddReplyButton.js